module.exports = ".s{\n  display: none;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/+app/+video/video.component.css
// module id = 595
// module chunks = 0